import styled from "@emotion/styled";
import { imageFromPlatformName, URLIcon } from "@stepfinance/react";
import type { FC } from "react";

import { IconTextContainer, TokenIconText } from "../../shared";
import CellValue from "../../Table/CellValue";

export const PlatformCell: FC<{ platform: string }> = ({ platform }) => {
  return (
    <StyledCell>
      <URLIcon src={imageFromPlatformName(platform) ?? ""} />
      <TokenIconText bold>
        <CellValue cellType="shortenedText">{platform}</CellValue>
      </TokenIconText>
    </StyledCell>
  );
};

const StyledCell = styled(IconTextContainer)`
  display: flex;
  align-items: center;
  margin-right: 16px;
`;
